import { Box, Text } from "@chakra-ui/react";
import {
  Area,
  AreaChart as RechartArea,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useColorModeValue } from "../../ui/color-mode";
import { darkMode, lightMode } from "../../../theme/config";

export default function AreaRepresentation({
  data,
  title,
  width = "100%",
  height = 300,
  margin = { top: 10, right: 20, left: 0, bottom: 20 },
  gradientId = "colorValue",
  gradientStartColor = "#8B5CF6",
  gradientEndColor = "#8B5CF6",
  gradientStartOpacity = 0.8,
  gradientEndOpacity = 0.1,
  strokeColor = "#8B5CF6",
  gridStroke = "#E5E7EB",
  xAxisTickFontSize = "16px",
  yAxisTickFontSize = "16px",
  xAxisDataKey = "value",
  yAxisDataKey = "count",
  axisTickColor = "#6B7280",
  tooltipBg = "#fff",
  tooltipBoxShadow = "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  areaType = "natural",
  animationDuration = 1500,
  dot = false,
  activeDot = { r: 6, stroke: "#8B5CF6", strokeWidth: 2, fill: "#fff" },
  tooltipValueFormatter = (value) => [`${value} registrations`, "count"],
  tooltipLabelFormatter = (label) => label,
  cursorStroke = "#8B5CF6",
  cursorStrokeWidth = 1,
  cursorDasharray = "5 5",
}) {

  const bgColor = useColorModeValue(
    lightMode.boxBackgroundColor,
    darkMode.boxBackgroundColor
  );

  return (
    <Box p={5} shadow="md" borderRadius="lg" width={width} bg={bgColor}>
      <Text fontSize="xl" fontWeight="semibold" p={2}>
        {title}
      </Text>

      <ResponsiveContainer width="100%" height={height}>
        <RechartArea data={data} margin={margin}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={gradientStartColor} stopOpacity={gradientStartOpacity} />
              <stop offset="95%" stopColor={gradientEndColor} stopOpacity={gradientEndOpacity} />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={false} stroke={gridStroke} />

          <XAxis
            dataKey={xAxisDataKey}
            axisLine={false}
            tickLine={false}
            padding={{ left: 10, right: 10 }}
            style={{ fontSize: xAxisTickFontSize }}
            tick={{ fill: axisTickColor }}
            tickMargin={10}
          />

          <YAxis
            dataKey={yAxisDataKey}
            axisLine={false}
            tickLine={false}
            tickMargin={10}
            style={{ fontSize: yAxisTickFontSize }}
            tick={{ fill: axisTickColor }}
            tickCount={6}
          />

          <Tooltip
            contentStyle={{
              backgroundColor: tooltipBg,
              borderRadius: "8px",
              boxShadow: tooltipBoxShadow,
              border: "0",
              padding: "12px",
            }}
            formatter={tooltipValueFormatter}
            labelFormatter={tooltipLabelFormatter}
            cursor={{
              stroke: cursorStroke,
              strokeWidth: cursorStrokeWidth,
              strokeDasharray: cursorDasharray,
            }}
          />

          <Area
            type={areaType}
            dataKey={yAxisDataKey}
            stroke={strokeColor}
            strokeWidth={2}
            fill={`url(#${gradientId})`}
            fillOpacity={1}
            animationDuration={animationDuration}
            dot={dot}
            activeDot={activeDot}
          />
        </RechartArea>
      </ResponsiveContainer>
    </Box>
  );
}
